import React, { useState, useEffect } from "react";
import { Button } from '../../Component/CommonFormEle';
import { GetDeviceFeatureSerials, CreateDeviceFeatureSerials } from 'js/Api/index';
import { toast } from "react-hot-toast";

const FeatureGroupList = () => {

    const [DeviceSeailFeatures, setDeviceSeailFeatures] = useState(null);

    const LoadDeviceSerials = async () => {
        const result = await GetDeviceFeatureSerials();
        if (result.success) {
            setDeviceSeailFeatures(result.data);
        }
    }

    useEffect(() => {
        LoadDeviceSerials();
    }, []);

    const formatDateTime = (timeString) => {
        if (!timeString) {
            return "Unknown Time";
        }
        const utcTimeString = timeString.endsWith("Z") ? timeString : `${timeString}Z`;
        const date = new Date(utcTimeString);
        if (isNaN(date.getTime())) {
            return "Invalid Date";
        }
        return `${date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true, }).replace(" ", "")} on ${date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", })}`;
    };

    const [showInviteModal, setShowInviteModal] = useState(false);

    const [newDesviceSub, setnewDesviceSub] = useState({ serialNo: "", durationInMon: "", feature_id: "", sip_username: "", sip_password: "", sip_domain: "", sip_phone: "" });

    const handleAdminInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setnewDesviceSub({
            ...newDesviceSub,
            [name]: value,
        });
    };

    console.log(newDesviceSub);

    const CreateNewSubscription = async (e) => {
        e.preventDefault();
        if (newDesviceSub.serialNo === "" || newDesviceSub.durationInMon === "" || newDesviceSub.feature_id === "") {
            toast.error("Please add serial no, Duration & select feature");
            return;
        }

        const result = await CreateDeviceFeatureSerials({
            serialNo: newDesviceSub.serialNo,
            featureId: newDesviceSub.feature_id,
            durationInMonths: newDesviceSub.durationInMon,
            sip_username: newDesviceSub.sip_username, sip_password: newDesviceSub.sip_password, sip_domain: newDesviceSub.sip_domain, sip_phone: newDesviceSub.sip_phone
        });

        if (result.success) {
            await LoadDeviceSerials();
            setShowInviteModal(false);
            setnewDesviceSub({ serialNo: "", durationInMon: "", feature_id: "" })
            toast.success("Feature created successfully!");
        } else {
            toast.error(result.error);
        }

        return;
    };

    return (
        <div className="midde_cont">
            <div className="container-fluid">
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title">
                            <h2>CareWindow Plus+</h2>
                        </div>
                    </div>
                </div>

                <div class="white_shd full margin_bottom_30">
                    <div className="full inner_elements">
                        <div className="tabbar padding_infor_info">
                            <Button onClick={() => { setShowInviteModal(true) }} variant="action-popup">
                                Create New Device Subscription +
                            </Button>
                            <div class="clear"></div>
                            <br />
                            <div className="row">
                                <div className="col-md-12">
                                    {DeviceSeailFeatures !== null &&
                                        <div className="table-wrap">
                                            <table className="table table-responsive-xl table-hover">
                                                <thead>
                                                    <tr>
                                                        <th width="14%">Created On</th>
                                                        <th width="15%">Feature Name</th>
                                                        <th width="12%">Serial No</th>
                                                        <th width="10%">Duration (in Months)</th>
                                                        <th width="14%">Valid From</th>
                                                        <th width="14%">Valid To</th>
                                                        <th>Email ID</th>
                                                        <th width="5%">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {DeviceSeailFeatures?.devices && DeviceSeailFeatures.devices.length > 0 &&
                                                        <>
                                                            {DeviceSeailFeatures.devices.map((a) => (
                                                                <tr key={a.id}>
                                                                    <td>{formatDateTime(a.createdAt)}</td>
                                                                    <td>{a.featureName}</td>
                                                                    <td>{a.serialNo}</td>
                                                                    <td>{a.durationMonths}</td>
                                                                    <td>{a.validFrom && formatDateTime(a.validFrom)}</td>
                                                                    <td>{a.validTo && formatDateTime(a.validTo)}</td>
                                                                    <td>{a.recoveryEmail}</td>
                                                                    <td>
                                                                        {a?.featurePurchaseId === null || a?.featurePurchaseId === undefined ?
                                                                            <span style={{ fontSize: "1.2rem", color: "red", fontWeight: "bold" }}>X</span> : <i className="fa fa-check-circle" style={{ fontSize: "1.2rem", color: "green" }}></i>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </div>
                            </div>

                            {showInviteModal && (
                                <div className="modal">
                                    <div className="modal-content" style={{ width: "700px" }}>
                                        <div className="modal-header">
                                            <h1>New subscription</h1>
                                            <Button onClick={() => { setShowInviteModal(false) }} variant="modal-close">
                                                &times;
                                            </Button>
                                        </div>
                                        <form className="contact-form">
                                            <div className="form-group mt-2">
                                                <label>Serial No</label>
                                                <input className="form-control" type="text" name="serialNo" value={newDesviceSub.serialNo} onChange={handleAdminInputChange} />
                                            </div>
                                            <div className="form-group">
                                                <label>Duration (in Months)</label>
                                                <input style={{ width: "30%" }} className="form-control" type="number" name="durationInMon" value={newDesviceSub.durationInMon} onChange={handleAdminInputChange} />
                                            </div>
                                            <div className="form-group">
                                                <label>Select Feature</label>
                                                <select className="form-control" name="feature_id" onChange={handleAdminInputChange}>
                                                    <option value="">Select Feature</option>
                                                    {DeviceSeailFeatures?.master_feature_groups && DeviceSeailFeatures.master_feature_groups.length > 0 &&
                                                        <>
                                                            {DeviceSeailFeatures.master_feature_groups.map((a) => (
                                                                <option value={a.masterFeatureId}>{a.masterFeatureName}</option>
                                                            ))}
                                                        </>
                                                    }
                                                </select>
                                            </div>
                                            <div class="row mt-3">
                                                <div class="col">
                                                    <h4>SIP Account Details</h4>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <div className="form-group">
                                                        <label>SIP Username</label>
                                                        <input className="form-control" type="text" name="sip_username" value={newDesviceSub.sip_username} onChange={handleAdminInputChange} />
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div className="form-group">
                                                        <label>SIP Password</label>
                                                        <input className="form-control" type="text" name="sip_password" value={newDesviceSub.sip_password} onChange={handleAdminInputChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <div className="form-group">
                                                        <label>SIP Domain</label>
                                                        <input className="form-control" type="text" name="sip_domain" value={newDesviceSub.sip_domain} onChange={handleAdminInputChange} />
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div className="form-group">
                                                        <label>SIP Phone No</label>
                                                        <input className="form-control" type="text" name="sip_phone" value={newDesviceSub.sip_phone} onChange={handleAdminInputChange} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="modal-footer">
                                                <Button onClick={() => { setShowInviteModal(false) }} variant="cancel">
                                                    Cancel
                                                </Button>
                                                <Button onClick={CreateNewSubscription} variant="blue">
                                                    Create Subscription
                                                </Button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FeatureGroupList;